<template lang="pug">
    .game-info
        .game-info__statistics(:style="interactiveFlashCardsStyles")
            .game-info__item(:class="{'game-info__item_is-full-width': isColumnsGameWithMoreThanFourPlayers}")
                .game-info__player-setting(
                    :class="{'game-info__player-setting_tiny': isColumnsGameWithMoreThanFourPlayers}"
                )
                    cs-button(
                        @click="$emit('openModalFrame')",
                        color="green",
                        :style="{'background-color': colorForStudent + '!important'}",
                        :disabled="!isGamePaused",
                    )
                        | {{ playerName }}
                        svg-icon(name="cog" :aria-hidden="true" size="small")
            .game-info__item
                .game-info__scores(:class="{'game-info__scores_tiny': isColumnsGameWithMoreThanFourPlayers}")
                    img.game-info__answer-img(
                        src="../../../assets/images/trainer/goodAnswer.png"
                        :style="displayImgStyles"
                    )
                    transition(name="left-score" mode="out-in")
                        span.left-score(:key="score.left") {{ score.left }}
                    span.colon {{ ":" }}
                    transition(name="right-score" mode="out-in")
                        span.right-score(:key="score.right") {{ score.right }}
                    img.game-info__answer-img(
                        src="../../../assets/images/trainer/badAnswer.png"
                        :style="displayImgStyles"
                    )
            .game-info__item
                .game-info__time(:class="{'game-info__time_tiny': isColumnsGameWithMoreThanFourPlayers}")
                    img.time__icon(
                        src="../../../assets/images/trainer/time.svg"
                        :style="displayImgStyles"
                    )
                    span.time__value {{ timeWithHours }}
        component(
            v-if="displayGameInfo"
            :is="slug",
            :slug="slug",
            :current-user-position="place - 1",
            @parametersUpdate="$emit('parametersUpdate')",
            :is-game-paused="isGamePaused"
        )
</template>

<script>
    const AdditionAndSubtractionWithTime = () =>
        import('../multiplayer-game-info-individual-settings/AdditionAndSubtractionWithTime.vue');
    const InteractiveFlashCards = () =>
        import('../multiplayer-game-info-individual-settings/InteractiveFlashCards.vue');
    const AnzanWithTime = () =>
        import('../multiplayer-game-info-individual-settings/AdditionAndSubtractionWithTime.vue');
    const Equation = () => import('../multiplayer-game-info-individual-settings/Equation.vue');
    const RootsAndDegrees = () => import('../multiplayer-game-info-individual-settings/RootsAndDegrees');
    const RootsAndSquares = () => import('../multiplayer-game-info-individual-settings/RootsAndDegrees');

    export default {
        props: {
            playerName: {
                type: String,
                default: '',
            },
            score: {
                type: Object,
                default: null,
            },
            timeWithHours: {
                type: String,
                default: '',
            },
            playersNumber: {
                type: Number,
                default: 0,
            },
            place: {
                type: Number,
                default: 0,
            },
            colorForStudent: {
                type: String,
                default: '',
            },
            displayGameInfo: {
                type: Boolean,
                default: false,
            },
            isGamePaused: {
                type: Boolean,
                default: false,
            },
            slug: {
                type: String,
                default: '',
            },
        },
        computed: {
            displayImgStyles() {
                if (
                    (window.innerWidth <= 1440 && this.playersNumber > 5) ||
                    (this.slug === 'AdditionAndSubtraction' && this.playersNumber === 8) ||
                    (window.innerWidth <= 1200 && this.slug === 'AdditionAndSubtraction') ||
                    (window.innerWidth < 1440 && this.playersNumber > 2 && this.slug === 'InteractiveFlashCards')
                ) {
                    return {
                        display: 'none',
                    };
                }
                return {};
            },
            interactiveFlashCardsStyles() {
                return (
                    this.slug === 'InteractiveFlashCards' &&
                    window.innerWidth < 1439 &&
                    this.playersNumber === 3 &&
                    'flex-wrap: nowrap'
                );
            },
            isColumnsGameWithMoreThanFourPlayers() {
                return this.playersNumber >= 4 && ['AdditionAndSubtraction', 'Anzan'].includes(this.slug);
            },
        },
        components: {
            AdditionAndSubtractionWithTime,
            InteractiveFlashCards,
            AnzanWithTime,
            Equation,
            RootsAndDegrees,
            RootsAndSquares,
        },
    };
</script>

<style lang="scss" scoped>
    .game-info {
        display: flex;
        align-items: center;
    }

    .game-info__statistics {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin: -5px -5px 5px;
        user-select: none;
    }

    .game-info__item {
        padding: 5px;
    }

    .game-info__item_is-full-width {
        width: 100%;
    }

    .game-info__player-setting {
        margin: 0 10px 8px;
        user-select: none;
        @include media($xl) {
            margin: 0;
        }
        &.three-players {
            margin: 0 80px 8px;
        }
        &.seven-players,
        &.eight-players {
            margin: 0 65px 8px;
        }
    }

    .game-info__player-setting .cs-button {
        display: flex;
        width: 90px;
        height: 30px;
        @include media($xl) {
            width: 100px;
        }
        padding: 0;
        font-size: 14px;
        font-weight: 500;
        :last-child {
            margin-left: 6px;
        }
    }

    .game-info__player-setting_tiny {
        margin: 0 auto;
        width: 100px;
    }

    .game-info__player-setting_tiny .cs-button {
        width: 100%;
        font-size: 11px;
        @media screen and (max-width: 1819px) {
            height: 25px;
        }
    }

    .game-info__player-setting .cs-button--disabled {
        color: $x-color-white;
    }

    .game-info__scores,
    .game-info__time {
        width: auto;
        height: 31px;
        padding: 5px 10px;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        margin-left: 10px;
        user-select: none;
    }

    .game-info__scores_tiny {
        padding: 3px;
        @media screen and (max-width: 1819px) {
            height: 25px;
            font-size: 13px;
            padding: 1px;
            margin-left: 0 !important;
            .left-score,
            .right-score {
                font-size: 10px;
                line-height: 13px;
            }
        }
        @media screen and (max-width: 1439px) {
            font-size: 8px;
            margin-left: 0 !important;
            .left-score,
            .right-score {
                font-size: 8px;
                line-height: 9px;
            }
        }
    }

    .game-info__time {
        min-width: 110px;
        text-align: center;
    }

    .game-info__time_tiny {
        min-width: 95px;
        padding: 5px;
        margin-left: 0;
        @media screen and (max-width: 1819px) {
            height: 25px;
            padding: 1px;
            min-width: 50px;
            .time__value {
                font-size: 10px;
                line-height: 13px;
            }
        }
        @media screen and (max-width: 1439px) {
            padding: 0;
            min-width: 57px;
            .time__value {
                font-size: 8px;
                line-height: 9px;
            }
        }
    }

    .game-info__scores {
        margin-left: 0;
        @include media($xl) {
            margin-left: 10px;
        }
    }

    .left-score,
    .right-score {
        font-weight: 500;
        font-size: 14px;
        margin: 0 5px;
    }

    .game-info__answer-img {
        width: 12px;
        height: 12px;
    }

    .time__icon {
        width: 19px;
        height: 19px;
    }

    .time__value {
        font-weight: 500;
        color: $x-color-black;
        font-size: 14px;
        line-height: 17px;
        width: 100%;
    }

    .play-box__game-info_is-5-screens,
    .play-box__game-info_is-6-screens,
    .play-box__game-info_is-7-screens,
    .play-box__game-info_is-8-screens {
        .game-info__statistics {
            flex-wrap: nowrap;
            .game-info__player-setting {
                margin: 0;
                .cs-button {
                    font-size: 10px;
                    line-height: 12px;
                    height: 20px;
                    width: 68px;
                }
            }
        }
        .game-info__scores,
        .game-info__time {
            font-size: 10px;
            line-height: 12px;
            height: 20px;
            margin: 0;
        }
        .game-info__scores {
            margin: 0 5px 0 5px;
        }
        .game-info__time {
            @media screen and (max-width: 1800px) {
                .time__icon {
                    display: none;
                }
            }
        }
    }
    .game-info-for-anzan {
        @media screen and (max-width: 1439px) {
            .game-info__player-setting {
                margin: 0 0 10px;
            }
        }
    }

    .game-info__individual-settings {
        display: flex;
        justify-content: center;
        margin-top: 8px;
        align-self: center;
    }
    .game-info__choose-time,
    .game-info__difficult,
    .game-info__actions {
        height: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 0;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        &:nth-child(-n + 2) {
            margin-right: 5px;
            @include media($xl) {
                margin-right: 8px;
            }
        }
        .svg-icon {
            color: #2187ff;
            margin: 0 5px;
            @include media($xl) {
                margin: 0 8px;
            }
        }
        .game-info__value {
            font-size: 14px;
        }
    }
</style>
